import { invitationService } from "../services/invitation.service";
import { invitationConstants } from "../constants/invitation.constants";

export const invitationActions = {
  init,
  invite,
  close,
  getBySender,
  resend,
};

function init() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() {
    return {
      type: invitationConstants.OPEN_MODAL,
    };
  }
}

function invite(
  fromFirstName,
  fromLastName,
  email,
  clientId,
  clientGuid,
  isAdmin
) {
  return (dispatch) => {
    dispatch(
      request({
        fromFirstName,
        fromLastName,
        email,
        clientId,
        clientGuid,
        isAdmin,
      })
    );

    invitationService
      .invite(fromFirstName, fromLastName, email, clientId, clientGuid, isAdmin)
      .then(
        (response) => {
          dispatch(success(response.data));
        },
        (error) => {
          dispatch(failure(error.response.data));
        }
      );
  };

  function request(requestParameters) {
    return {
      type: invitationConstants.SEND_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return { type: invitationConstants.SEND_SUCCESS, payload: paginatedResult };
  }
  function failure(error) {
    return { type: invitationConstants.SEND_FAILURE, payload: error };
  }
}

function close() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() {
    return {
      type: invitationConstants.CLOSE_MODAL,
    };
  }
}

function getBySender(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    invitationService.getBySender(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: invitationConstants.GET_BY_SENDER_ID_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: invitationConstants.GET_BY_SENDER_ID_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: invitationConstants.GET_BY_SENDER_ID_FAILURE };
  }
}

function resend(invitationId) {
  return (dispatch) => {
    dispatch(request(invitationId));

    invitationService.resend(invitationId).then(
      (response) => {
        dispatch(success(invitationId));
      },
      (error) => {
        dispatch(failure(error.response?.data || "Failed to resend invitation"));
      }
    );
  };

  function request(invitationId) {
    return {
      type: invitationConstants.RESEND_REQUEST,
      payload: invitationId,
    };
  }
  function success(invitationId) {
    return {
      type: invitationConstants.RESEND_SUCCESS,
      payload: invitationId,
    };
  }
  function failure(error) {
    return {
      type: invitationConstants.RESEND_FAILURE,
      payload: error,
    };
  }
}
